// extracted by mini-css-extract-plugin
export default {"Notifications":"Notifications_Notifications__MjMTY","num":"Notifications_num__9Pu4S"};